// extracted by mini-css-extract-plugin
module.exports = {"additional-content-box":"refund_additional-content-box__1i52L","additional-content-box-title":"refund_additional-content-box-title__23l51"};